import useTranslation from 'next-translate/useTranslation'

import { getStats } from '../functions'

function VioletSection() {
  const { t } = useTranslation('forBrands')
  const stats = getStats(t)

  const linkAttrs = {
    href: 'https://www.brandbuddies.pl/',
    target: '_blank',
    rel: 'noreferrer',
  }

  return (
    <section className="py-4 box">
      <div className="flex flex-col items-center mx-auto space-y-4 max-w-7xl md:flex-row md:space-x-4">
        <div className="flex-shrink-0 w-full max-w-sm md:w-1/3">
          <a {...linkAttrs} className="items-center ">
            <img
              src="/images/for-brands/brandbuddies.svg"
              className="w-full mx-auto md:mx-0"
            />
          </a>
        </div>
        <p key={0} className="text-base xl:text-xl">
          {t('forBrands:brandbuddies')}
        </p>
      </div>
      <div className="flex flex-wrap justify-center mt-6 gap-y-4">
        {stats.map(({ statistic, description }, index) => (
          <div
            className="px-4 md:px-8 w-1/2 lg:w-[33%] text-left text-white border-white"
            key={index}
          >
            <h5 className="font-bold px-6 py-3 text-center mb-3 bg-white text-[#85cfc4]">
              {statistic}
            </h5>
            <p className="text-sm xl:text-3xl">{description}</p>
          </div>
        ))}
      </div>
    </section>
  )
}

export default VioletSection
